import { library } from "@fortawesome/fontawesome-svg-core";
import { faThumbsUp } from "@fortawesome/pro-duotone-svg-icons";

library.add(faThumbsUp);

export { faThumbsUp };
